import { FOKUS_RING } from './fokus';

// Die Klassen der Eingabefelder — an EINER Stelle (A14.1).
//
// DAS FOKUSBILD STEHT SEIT A44 IN lib/fokus.ts und nicht mehr hier.
// Hier stand `focus:border-akzent focus:outline-none` — an `:focus`,
// nicht an `:focus-visible`. Damit faerbte JEDES angeklickte Feld seinen
// Rand um: eine Anzeige, die "hier hast Du zuletzt geklickt" sagte statt
// "hier bist Du mit der Tastatur".
//
// WARUM DAS HIER STEHT UND NICHT VIERMAL IM QUELLTEXT
//   Vier Dateien trugen je eine eigene Konstante `inputClass` mit
//   derselben Zeichenkette: NeuerKundeForm, RechnungsadresseSection,
//   LieferadresseEditor und KundeEditor. Drei davon hatten kein
//   `min-h-[44px]`, die vierte schon — dieselbe Klasse, vier Fassungen,
//   und niemand hat den Unterschied gesehen. Genau die Verdopplung, die
//   Designprinzip 4 meint.
//
// DIE 44 SIND NICHT VERHANDELBAR
//   CLAUDE.md nennt 44 x 44 Pixel als Untergrenze fuer Beruehrziele.
//   `px-3 py-2` ergibt bei 14-px-Text 38 Pixel, `py-2.5` ergibt 42 —
//   beides im laufenden Build nachgemessen, beides zu wenig. `min-h`
//   statt einer festen Hoehe, damit ein Feld mit zwei Zeilen Text
//   trotzdem wachsen darf.

/**
 * Das gewoehnliche Eingabefeld in einem Formular: volle Breite, eigene
 * Zeile oder Rasterzelle.
 *
 * `min-w-0` ist Pflicht und kein Zierrat (Falle K11): ein `<input>`
 * bringt ueber sein `size`-Attribut rund 180 px Eigenbreite mit und
 * schrumpft im Flexbereich ohne das nicht darunter.
 */
export const FELD_KLASSE =
  'min-h-[44px] w-full min-w-0 rounded-md border border-line bg-cream px-3 py-2.5 ' +
  `text-sm ${FOKUS_RING}`;

/**
 * Das schmale Feld, das in einer Zeile neben anderem steht — ein Datum
 * neben seinem Knopf, eine Sendungsnummer neben ihrem Etikett.
 *
 * Unterschied zur grossen Fassung: keine feste Breite und weniger
 * Polsterung links und rechts. Die HOEHE ist dieselbe; ein Feld, das man
 * mit dem Finger nicht trifft, wird nicht dadurch besser, dass es in
 * einer Zeile steht.
 */
export const FELD_KLASSE_ENG =
  'min-h-[44px] min-w-0 rounded-md border border-line bg-cream px-2 py-1 ' +
  `text-sm ${FOKUS_RING}`;
